
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';


import ScrollToTopButton from './components/ScrollToTopButton';
import AboutUs from './components/AboutUs';
import ServiciosLegales from './components/ServiciosLegales';
import Contact from './components/Contact';
import TestimoniosCard from './components/TestimoniosPage';
import News from './components/News';
import { pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";



function App() {
  return (
    <div className="app-container">
      <Header />
      
      
      <main className="main-content">
        <br></br>
        <img
          className="d-block w-100"
          src="/images/IMG_3.jpg"
          alt="Segundo slide"
        />
        <br></br>

        <h3 className="text-center mb-3 section-title"><em>"Los invitamos a nuestro espacio donde la estrategia y la confianza se encuentran..."</em></h3>
        <br></br>
        <div >
          <section id="home" className="text-center mb-5">
            <p className='text-center mb-5 lead highlight-text'>
              <em>" Defendemos con firmeza los derechos de nuestros clientes. Nuestra práctica está guiada por la seriedad, la técnica procesal y 
              el profundo respeto por las garantías constitucionales. Nos enfrentamos a cada causa con dedicación, confidencialidad y enfoque profesional. "</em>

            </p>
          </section>
          <section id="nosotros"> 
            <AboutUs />
          </section>

          <br></br>
          <section id="Servicios">
            <h2 className="text-center mb-3 section-title"><em>Servicios Legales</em></h2>
            <p className="services-intro">
              <em>
              En nuestro estudio brindamos un acompañamiento jurídico integral, adaptado a las necesidades de cada persona. Contamos con experiencia en diversas ramas del Derecho Penal, y ofrecemos un enfoque estratégico, humano y comprometido en cada etapa del proceso.
              Nuestros servicios están diseñados para garantizar una defensa técnica sólida, respetando los derechos fundamentales y buscando siempre la mejor solución posible para nuestros clientes. 
              </em>
            </p>
            <ServiciosLegales /> 
          </section>
          <section id="Testimonios">
            <h2 className="text-center mb-3 section-title"><em>Testimonios y Casos de Éxito</em></h2>
            <p className="services-intro">
              <em>
              Creemos en una defensa estratégica, humana y comprometida. 
                En esta sección, compartimos resoluciones judiciales reales que 
                demuestran cómo aplicamos nuestra experiencia para proteger 
                los derechos de nuestros clientes. Lo invitamos a navegar 
                por nuestros casos de éxito para conocer nuestro trabajo en acción.
              </em>
            </p>
            <TestimoniosCard />
          </section>
          <section id="Noticias">
            
            <News />
          </section>

          <section id="Contact">
            
            <Contact />
          </section>
          
        </div>
        
        
      <ScrollToTopButton />
      </main>
      <Footer />
    </div>
  );
}

export default App;
